const DEFAULT_AUDIO_CONSTRAINTS = {
  autoGainControl: false,
  echoCancellation: true,
  noiseSuppression: false,
};

const STORAGE_FLAG_KEYS = {
  autoGainControl: "AutoGainControl",
  echoCancellation: "EchoCancellation",
  noiseSuppression: "NoiseSuppression",
};

const BOOLEAN_TRUE_VALUES = new Set(["1", "true", "yes", "on", "enabled"]);
const BOOLEAN_FALSE_VALUES = new Set(["0", "false", "no", "off", "disabled"]);

const readStoredConstraintPreference = (constraintName) => {
  if (typeof window === "undefined" || !window.localStorage) {
    return undefined;
  }

  const storageKey = STORAGE_FLAG_KEYS[constraintName];
  if (!storageKey) {
    return undefined;
  }

  const storedValue = window.localStorage.getItem(storageKey);
  if (storedValue === null) {
    return undefined;
  }

  const normalizedValue = String(storedValue).trim().toLowerCase();
  if (BOOLEAN_TRUE_VALUES.has(normalizedValue)) {
    return true;
  }

  if (BOOLEAN_FALSE_VALUES.has(normalizedValue)) {
    return false;
  }

  return undefined;
};

export const getPreferredAudioConstraints = () => {
  const resolvedProcessingFlags = Object.entries(DEFAULT_AUDIO_CONSTRAINTS).reduce(
    (constraints, [constraintName, defaultValue]) => {
      const storedValue = readStoredConstraintPreference(constraintName);
      constraints[constraintName] =
        typeof storedValue === "boolean" ? storedValue : defaultValue;
      return constraints;
    },
    {}
  );

  if (
    typeof navigator === "undefined" ||
    !navigator.mediaDevices ||
    typeof navigator.mediaDevices.getSupportedConstraints !== "function"
  ) {
    return { ...resolvedProcessingFlags };
  }

  const supportedConstraints = navigator.mediaDevices.getSupportedConstraints();

  return Object.entries(resolvedProcessingFlags).reduce(
    (constraints, [constraintName, enabled]) => {
      if (supportedConstraints[constraintName] !== false) {
        constraints[constraintName] = enabled;
      }

      return constraints;
    },
    {}
  );
};

export const buildVoiceOnlySessionOptions = () => ({
  sessionDescriptionHandlerOptions: {
    constraints: {
      audio: getPreferredAudioConstraints(),
      video: false,
    },
  },
});
